export const environment = {
    production: false,
    URL: 'https://j6gghsbuc4.execute-api.us-east-1.amazonaws.com/dev/',
    urlFile: 'https://j6gghsbuc4.execute-api.us-east-1.amazonaws.com/dev',
    VERSION: '1.0.0',
    PAGE_SIZE: 10,
    TIMEOUT: 29000,
    cognito: {
        authUrl: 'https://cognito-idp.us-east-1.amazonaws.com/us-east-1_DJ3Y5LgoX/',
        clientId: '79aq35r2gh9guvrigon3ild2mh',
        region: 'us-east-1',
        userPoolId: 'us-east-1_DJ3Y5LgoX',
        domain: 'test.local',
        redirectUri: 'https://test.tadiclist.com',
        loginUri: 'http://test.tadiclist.com/login',
        logoutUri: 'http://test.tadiclist.com/logout'
    },
    apiKeyGoogle: 'AIzaSyAIEupgsctODMUaDyRU6Pz2PbBRgWlaMxM'
};
